export default __webpack_public_path__ + "9bc2f60fabf931186caba232c11305b9.png";